import { Tag } from 'antd';
import styles from './RoundTag.module.scss';

/** `pill` — fully rounded ends; `rounded` — a rectangle with softened corners. */
export type TagShape = 'pill' | 'rounded';

type Props = {
  label: string;
  color?: string | null;
  shape?: TagShape;
};

export const RoundTag = ({ label, color, shape = 'pill' }: Props) => {
  const resolved = color ?? undefined;
  return (
    <Tag
      className={`${styles.tag} ${shape === 'rounded' ? styles.rounded : ''}`}
      style={{ color: resolved, borderColor: resolved }}
    >
      <span className={styles.dot} style={{ background: resolved }} />
      {label}
    </Tag>
  );
};
